import React, { useCallback } from 'react';
import { graphql, useFragment } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useConditionalFormattingEntryPoint as useConditionalFormattingEntryPointOld } from '@atlassian/jira-issue-navigator-action-conditional-formatting/src/controllers/entrypoint-context/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { ExperienceFailure } from '@atlassian/jira-issue-navigator-action-conditional-formatting/src/ui/experience/experience-failure.tsx';
import { JqlProvider } from '@atlassian/jira-business-entity-common/src/controllers/jql-context/index.tsx';
import { FormatRulesContainer as FormatRulesContainerOld } from '@atlassian/jira-business-conditional-formatting-sidebar/src/controllers/format-rules-store/index.tsx';
import { FormatRulesFragment as FormatRulesFragmentOld } from '@atlassian/jira-business-conditional-formatting-sidebar/src/ui/format-rules/FormatRules.tsx';
import { ErrorState } from '../error-state/index.tsx';
import type { ConditionalFormattingSidebarExperienceOld_project$key } from './__generated__/ConditionalFormattingSidebarExperienceOld_project.graphql';

/** @deprecated Duplicate any changes made here to ConditionalFormattingSidebarExperienceProps */
export type ConditionalFormattingSidebarExperiencePropsOld = {
	onClose: () => void;
	project: ConditionalFormattingSidebarExperienceOld_project$key | null;
};

/** @deprecated Duplicate any changes made here to ConditionalFormattingSidebarExperience */
export const ConditionalFormattingSidebarExperienceOld = ({
	onClose,
	project,
}: ConditionalFormattingSidebarExperiencePropsOld) => {
	const { entryPointReferenceSubject } = useConditionalFormattingEntryPointOld();

	const projectData = useFragment<ConditionalFormattingSidebarExperienceOld_project$key>(
		graphql`
			fragment ConditionalFormattingSidebarExperienceOld_project on JiraProject {
				projectId
				key
				...FormatRules @arguments(first: 20)
			}
		`,
		project,
	);
	const errorFallback = useCallback(
		({ error }: { error: Error }) => (
			<>
				<ExperienceFailure error={error} />
				<ErrorState onClose={onClose} />
			</>
		),
		[onClose],
	);

	if (projectData?.key == null) {
		return null;
	}

	return (
		<FormatRulesContainerOld>
			<JqlProvider jqlContext={`project = '${projectData?.key}'`}>
				<JiraEntryPointContainer
					entryPointReferenceSubject={entryPointReferenceSubject}
					id="conditionalFormattingSidebar"
					packageName="jiraIssueNavigatorActionConditionalFormatting"
					errorFallback={errorFallback}
					teamName="Keystone"
					fallback={<></>}
					runtimeProps={{
						projectId: projectData?.projectId ?? undefined,
						onClose,
						showOnboarding: false,
					}}
				/>
			</JqlProvider>
			<FormatRulesFragmentOld project={projectData ?? null} />
		</FormatRulesContainerOld>
	);
};

/** @deprecated Duplicate any changes made here to ConditionalFormattingSidebarExperience */
export const MaybeConditionalFormattingSidebarExperienceOld = componentWithCondition(
	() => fg('jira_list_conditional_formatting'),
	ConditionalFormattingSidebarExperienceOld,
	() => <></>,
);
